export default __webpack_public_path__ + "static/media/close.23c5e9e9.svg";